module.exports = __webpack_public_path__ + "static/base-tooltip-8da1f2ca494aba40f618c09268d76bb2.svg";